import { render, staticRenderFns } from "./UsersDetails.vue?vue&type=template&id=3e5b59fa&scoped=true"
import script from "./UsersDetails.vue?vue&type=script&lang=js"
export * from "./UsersDetails.vue?vue&type=script&lang=js"
import style0 from "./UsersDetails.vue?vue&type=style&index=0&id=3e5b59fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5b59fa",
  null
  
)

export default component.exports